// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__fs_ON","layout":"layout__Jebe_","layoutAbout":"layoutAbout__agwFL","copyright":"copyright__2IewT","home":"home__QVjat","layoutProjectOpen":"layoutProjectOpen__-pMS9","top":"top__3F3Gk","blog":"blog__2OMHr","persian":"persian__3oiE8","contacts":"contacts__2YWiK"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/styles.styl
// module id = G09o
// module chunks = 0